import { useEffect } from 'react';

/**
 * Lock body scroll while a fixed-position overlay is open. Restores the
 * previous inline overflow on cleanup so sibling modals don't fight over
 * the value.
 */
const useBodyScrollLock = (locked: boolean): void => {
  useEffect(() => {
    if (!locked) return undefined;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [locked]);
};

export default useBodyScrollLock;
